import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import ReactCountryFlag from "react-country-flag";

const CountryBox = ({ country, selected, onClick, isDashboard, bedsCount }) => {
    const countryCodeMap = {
      'UK': 'GB',
      'IRELAND': 'IE',
      'CANADA': 'CA',
      'AUSTRALIA': 'AU',
      'NEW ZEALAND': 'NZ',
      'GERMANY': 'DE',
      'United States': 'US',
      'India': 'IN',
    };
    const getCountryCode = (countryName) => {
      console.log('Getting code for:', countryName);
      return countryCodeMap[countryName] || 'GB';
    };
    return(
    <Box
      onClick={onClick}
      sx={{
        p: 2,
        minWidth: country.id === 'all' ? '140px' : '120px',
        border: '1px solid',
        borderColor: selected ? 'primary.main' : 'grey.200',
        borderRadius: 2,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        backgroundColor: selected ? 'primary.light' : 'background.paper',
        '&:hover': {
          borderColor: 'primary.main',
          backgroundColor: 'primary.lighter',
        }
      }}
    >
      {country.id === 'all' ? (
      <span style={{ fontSize: '24px' }}>🌎</span>
    ) :<ReactCountryFlag 
        countryCode={getCountryCode(country.countryName??country?.cname)} 
        svg 
        style={{
          width: '2em',
          height: '2em',
          borderRadius: '4px'
        }}
      />}
      <Typography variant="subtitle2" textAlign="center">
        {country.countryName??country?.cname}
      </Typography>
            {/* Show bed count */}
      {isDashboard&&<Typography variant="body2" color="text.secondary">
        Beds: {bedsCount ?? 0}
      </Typography>}
    </Box>)
}
export default CountryBox;